import { H1 } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import * as React from 'react';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';

type Props = {
    callToAction?: React.ReactNode;
    className?: string;
    title: React.ReactNode;
};

const PageTitle = ({ callToAction, className, title }: Props) => {
    if (!title) {
        return null;
    }
    return (
        <StyledTitle>
            <StyledTextH1
                className={className}
                data-testid="pageTitle"
            >
                {title}
            </StyledTextH1>
            {Boolean(callToAction) && <StyledCallToAction>{callToAction}</StyledCallToAction>}
        </StyledTitle>
    );
};

export default React.memo<Props>(PageTitle, isEqual);

const StyledTitle = styled.section`
    display: flex;
    justify-content: space-between;
`;

const StyledTextH1 = styled(H1)`
    && {
        display: block;
        margin: 32px 0 20px;
    }
`;

const StyledCallToAction = styled.span`
    margin: 64px 0 0;
`;
